export enum ChatChannelUpdateReason {
    lastMessage = 'lastMessage',
    attributes = 'attributes',

    lastReadMessageIndex = 'lastReadMessageIndex',
}
